/**
 * Steps that should not have the highlight glow animation.
 * These are typically loading/animation steps where the glow would be distracting.
 */
export const STEPS_WITHOUT_GLOW = [
  "upload-file-step",
  "extraction-animation-step",
  "question-answering-animation-step",
  "celebrate-answer-step",
  "first-answer-step",
  "first-answer-source-step",
  "download-file-step",
  "chat-thinking-step",
  "generate-answers-step",
  "database-files-step",
  "database-upload-step",
] as const

export type StepWithoutGlow = (typeof STEPS_WITHOUT_GLOW)[number]

/**
 * Check if a step ID should have the glow animation disabled
 */
export const isStepWithoutGlow = (stepId: string): boolean => {
  return STEPS_WITHOUT_GLOW.includes(stepId as StepWithoutGlow)
}
